import {Injectable} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {Observable} from "rxjs";
import {
    CreateMagayaNetworkConfigurationPayload,
    MagayaNetworkConfigurationEntity,
    UpdateMagayaNetworkConfigurationPayload
} from "./+state/magaya-network-configuration.models";
import {environment} from "@qwyk/hub/environment";
import {map, take} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class MagayaNetworkConfigurationService {

    constructor(private http: HttpClient) {
    }

    public show(organization_id: number): Observable<MagayaNetworkConfigurationEntity> {
        return this.http.get<{ data: MagayaNetworkConfigurationEntity }>(
            `${environment.backendServer}/api/console/organizations/${organization_id}/magaya-network-configuration`
        ).pipe(take(1), map(response => response.data));
    }

    public create(payload: CreateMagayaNetworkConfigurationPayload): Observable<MagayaNetworkConfigurationEntity> {
        return this.http.post<{ data: MagayaNetworkConfigurationEntity }>(
            `${environment.backendServer}/api/console/organizations/${payload.organization_id}/magaya-network-configuration`,
            {
                network_id: payload.network_id,
                superuser_username: payload.superuser_username,
                superuser_password: payload.superuser_password
            }
        ).pipe(take(1), map(response => response.data));
    }

    public update(entity: MagayaNetworkConfigurationEntity, payload: UpdateMagayaNetworkConfigurationPayload): Observable<MagayaNetworkConfigurationEntity> {
        return this.http.patch<{ data: MagayaNetworkConfigurationEntity }>(
            `${environment.backendServer}/api/console/organizations/${entity.organization_id}/magaya-network-configuration`,
            payload
        ).pipe(take(1), map(response => response.data));
    }

    public test(organization_id: number): Observable<MagayaNetworkConfigurationEntity> {
        return this.http.get<{ data: MagayaNetworkConfigurationEntity }>(
            `${environment.backendServer}/api/console/organizations/${organization_id}/magaya-network-configuration/test`
        ).pipe(take(1), map(response => response.data));
    }
}
